import React, { useState } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Paper,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Divider } from "semantic-ui-react";
import { DocumentTypes, PaymentMethodTypes } from "../../enums/enums";

export default function AgreementView({ ReturnFunction, ViewData }) {
  const [isCash, setIsCash] = useState(false);

  function getLabelPaymentMethodType(typePaymentMethod) {
    if (
      typePaymentMethod === PaymentMethodTypes.CreditCard.Id ||
      typePaymentMethod === PaymentMethodTypes.DebitCard.Id
    ) {
      return "Número de la tarjeta ";
    } else if (
      typePaymentMethod === PaymentMethodTypes.Cash.Id ||
      typePaymentMethod === PaymentMethodTypes.BilledCash.Id
    ) {
      setIsCash(true);
      return "Efectivo";
    } else {
      return "Número del CBU";
    }
  }

  const DataSection = ({ Data }) => (
    <Grid container spacing={2}>
      <Grid item md={2} xs={5}>
        <TextFieldReadOnly
          Label="Tipo de documento"
          Value={Data.documentTypeName}
        />
      </Grid>
      <Grid item md={3} xs={3}>
        <TextFieldReadOnly
          Label="Número de documento"
          Value={Data.documentNumber}
        />
      </Grid>
      <Grid item md={3} xs={4}>
        <FormControlLabel
          control={
            <Checkbox className="c-checkbox-primary" checked={Data.isCompany} />
          }
          label="Es Empresa"
          disabled
          style={{
            visibility:
              Data.documentTypeId === DocumentTypes.CUIT ? "visible" : "hidden",
          }}
        />
      </Grid>

      {Data.isCompany ? (
        <Grid item md={12} xs={12}>
          <TextFieldReadOnly Label="Razón Social" Value={Data.businessName} />
        </Grid>
      ) : (
        <>
          <Grid item md={6} xs={6}>
            <TextFieldReadOnly Label="Nombres" Value={Data.name} />
          </Grid>
          <Grid item md={6} xs={6}>
            <TextFieldReadOnly Label="Apellido" Value={Data.lastName} />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextFieldReadOnly
              Label="Fecha de nacimiento"
              Value={Data.birthDate}
            />
          </Grid>
        </>
      )}

      <Grid item md={6} xs={12}>
        <TextFieldReadOnly Label="E-mail" Value={Data.email} />
      </Grid>
      <Grid item md={3} xs={12}>
        <TextFieldReadOnly Label="Número de teléfono" Value={Data.phone} />
      </Grid>
      <Grid item md={3} xs={12}>
        <TextFieldReadOnly
          Label="Número de teléfono alternativo"
          Value={Data.altPhone}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <TextFieldReadOnly Label="Provincia" Value={Data.stateName} />
      </Grid>
      <Grid item md={5} xs={12}>
        <TextFieldReadOnly Label="Localidad" Value={Data.cityName} />
      </Grid>
      <Grid item md={6} xs={8}>
        <TextFieldReadOnly Label="Dirección" Value={Data.address} />
      </Grid>
      <Grid item md={2} xs={4}>
        <TextFieldReadOnly Label="Número" Value={Data.addressNumber} />
      </Grid>
      <Grid item md={2} xs={8}>
        <TextFieldReadOnly Label="Departamento" Value={Data.department} />
      </Grid>
      <Grid item md={2} xs={4}>
        <TextFieldReadOnly Label="Piso" Value={Data.departmentFloor} />
      </Grid>
    </Grid>
  );

  const TextFieldReadOnly = ({ Label, Value }) => (
    <FormControl fullWidth={true}>
      <TextField
        size="small"
        variant="outlined"
        label={Label}
        value={Value || ""}
        InputProps={{ readOnly: true }}
      />
    </FormControl>
  );

  return (
    <Paper elevation={3}>
      <Grid className="c-form" container spacing={3}>
        <Grid item md={12}>
          <h1>CONTRATO</h1>
        </Grid>
        <Grid item md={12}>
          <h2>Producto</h2>
          <Divider />

          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextFieldReadOnly
                Label="Producto"
                Value={ViewData.productName}
              />
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item md={12} xs={12}>
              <h2>Datos del Cliente</h2>
              <Divider />
              <DataSection Data={ViewData.customer} />

              {ViewData.billingId !== undefined && (
                <>
                  <h2 className="c-mb-0">Datos de Facturación</h2>
                  <Divider />
                  <DataSection Data={ViewData.billing} />
                </>
              )}
              {ViewData.saleId && (
                <>
                  <h2>Datos del bien</h2>
                  <Divider />
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="vehicleTypeName"
                          label="Tipo de vehículo"
                          value={ViewData.sale.vehicleTypeName}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="plateNumber"
                          label="Patente"
                          value={ViewData.sale.plateNumber}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="brand"
                          label="Marca"
                          value={ViewData.sale.brandName}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="model"
                          label="Modelo"
                          value={ViewData.sale.modelName}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="color"
                          label="Color"
                          value={ViewData.sale.colorName}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="fabricationYear"
                          label="Año de fabricación"
                          value={ViewData.sale.fabricationYear}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <FormControl fullWidth={true}>
                        <TextField
                          size="small"
                          variant="outlined"
                          name="mileage"
                          label="Kilometraje"
                          value={ViewData.sale.mileage}
                          InputProps={{ readOnly: true }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </>
              )}
              <h2>Datos del pago</h2>
              <Divider />
              <Grid container spacing={2}>
                <Grid item md={3} xs={12}>
                  <FormControl fullWidth={true}>
                    <TextField
                      size="small"
                      variant="outlined"
                      name="paymentType"
                      label="Medio de pago"
                      value={ViewData.payment.typeName || ""}
                      InputProps={{ readOnly: true }}
                    />
                  </FormControl>
                </Grid>
                {!isCash && (
                  <Grid item md={4} xs={12}>
                    <FormControl fullWidth={true}>
                      <TextField
                        size="small"
                        variant="outlined"
                        name="paymentNumber"
                        label={getLabelPaymentMethodType(
                          ViewData.payment.type || ""
                        )}
                        value={ViewData.payment.number}
                        InputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Grid>
                )}
                <Grid item md={3} xs={12}>
                  <FormControl fullWidth={true}>
                    <TextField
                      size="small"
                      variant="outlined"
                      name="externalSalesChannel"
                      label="Canal de Venta Externo"
                      value={ViewData.externalSalesChannel || ""}
                      InputProps={{ readOnly: true }}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid className="c-text-right" item md={12} xs={12}>
                <Button
                  className="c-ml-5 c-grid-btn c-btn-success"
                  onClick={ReturnFunction}
                >
                  Volver
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
